/**
 * Sticky header (views/home/sticky.php): slides in once the main nav has
 * scrolled above the viewport and out when it is back; the search button
 * opens the search row, Escape closes it; the burger returns to the top.
 */
export function initSticky() {
  const bar = document.querySelector('[data-sticky]');
  const nav = document.querySelector('.hp-nav');
  if (!bar || !nav || !('IntersectionObserver' in window)) return;

  const button = bar.querySelector('[data-sticky-search]');
  const form = bar.querySelector('.hp-sticky__search');

  const closeSearch = () => {
    if (!form || form.hidden) return;
    form.hidden = true;
    bar.classList.remove('is-search');
    button?.setAttribute('aria-expanded', 'false');
  };

  const setVisible = (visible) => {
    bar.classList.toggle('is-visible', visible);
    bar.toggleAttribute('inert', !visible);
    bar.setAttribute('aria-hidden', String(!visible));
    if (!visible) closeSearch();
  };

  new IntersectionObserver(([entry]) => {
    setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
  }).observe(nav);

  button?.addEventListener('click', () => {
    if (!form) return;
    const open = form.hidden;
    form.hidden = !open;
    bar.classList.toggle('is-search', open);
    button.setAttribute('aria-expanded', String(open));
    if (open) form.querySelector('input')?.focus();
  });

  bar.querySelector('[data-sticky-top]')?.addEventListener('click', (e) => {
    e.preventDefault();
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
  });

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeSearch(); });
}
